import { Component, QueryList, ViewChildren } from '@angular/core';
import { concentracionEntity, mayoresDeudoresEntity} from './../entities_riesgos/entities_riesgos';
import {ConcentracionService} from './../../../services/riesgo-credito/riesgos/concentracion.service';
import { mayoresdeudoresService } from './../../../services/riesgo-credito/riesgos/mayoresdeudores.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { PeriodosService } from '../../../services/riesgo-credito/riesgos/periodos.service';
import { formatear } from '../../funciones/funcionesGenerales';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';

@Component({
  selector: 'app-mayores-deudores',
  templateUrl: './mayores-deudores.component.html',
  styleUrl: './mayores-deudores.component.css'
})
export class MayoresDeudoresComponent {
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  public Filtros = FiltersM;
  
  // **** Variables de las graficas ****
  public skeletonColums = new Array(6);
  public skeleton = new Array(15);
  miles1 = true
  milTab1 = ' (Miles)'
  //Variables de graficas pie
  showLabelsPie: boolean = true;
  colorSchemePie : any = ['#6BAED6', '#A6D9C9', '#C5B0D5', '#F7B267', '#FEE191', '#BFD8B8', '#A8CBE8', '#F6A6A1', '#8FD8D2', '#7BAEBE' ];

  //Variables de graficas barras
  multi : any = [];
  multi2: any;
  showDataLabel: boolean = false;
  xAxisLabel = 'Saldo';
  yAxisLabel = ['Nombre socio'];
  colorScheme2 : any = ['#6BAED6',];
  tipoGraf = typesApex;
  tipoSelec = this.tipoGraf.BARHORIZONTAL;
  tipoSelec2 = this.tipoGraf.DONUT;
  etiquetas = [];
  // Variables tarjetas
  Mayores_deudores = 'Mayores deudores';
  suma : number = undefined;
  total: number;
  mayordeud: number = 0;
  persepectiva = false;
  // **** Variables de titulos y subtitulos
  Title: string = 'Mayores deudores'+this.milTab1;
  titleModal: string = '';
  subtitleModal: string = '';
  numDeud = 20;

  // **** Variables filtros ****
  public idInstitucion: number;
  public DatosAnios;
  public aniosDisponibles: any [];
  public mesesDisponibles: any [];
  public mes = 'feb';
  public anio = '2022';
  Subtitulo_grafica : string =this.mes +' • '+ this.anio.substring(2,4) +' | matriz | '+this.numDeud+' mayores';
  mesAnio = '';
  // VARIABLES PERSONALIZACION CATALAGO
  private bndInteres: boolean; // false -> sin intereses   true -> con intereses
  public submenus: number; 
  public smMoneda: String;

  // **** Variables de numero de deudores ****
  ndeud10 = false;
  ndeud20 = true;
  ndeud30 = false;
  ndeud40 = false;
  ndeud50 = false;
  // **** Variables para el formateo de numeros
  separador:string =  ","; // separador para los miles
  sepDecimal:string = '.'; // separador para los decimales
  //
  dataSource: any = [];
  data: any;
  datos_pie = [];
  datosTablaPie = [];
  etiquetasPie
  // **** Variables del web service ****
  mayoresdeudores = new mayoresDeudoresEntity;
  concentracion = new concentracionEntity;
  concentracionPer = new concentracionEntity;
  periodo = 22022;
  // **** Variables de activación de graficas normales y modales  ****
  //Variavles grafizas zoana 1
  gtablas: boolean = false;
  //Variables graficas zona 2
  tablaPie: boolean = false;
  //Variables graficas Modal
  gMayoresModal: boolean = false;
  gtablasModal: boolean = false;
  gCarteraModal: boolean = false;
  public modalOpen: boolean = false;
  public iconoExportar: string = '';
  public labelsModal: boolean = false;
  // **** Constructor ****
  constructor(
    private concentracionService: ConcentracionService,
    private periodosService: PeriodosService,
    private mayoresdeudoresService: mayoresdeudoresService,
    private excelservices: ExcelService,
    private translate: TranslateService,
    public dataService: DataService,
    private cookies: CookieService
  ){
    formatear.momentAbrev();
    this.idInstitucion = Number(cookies.get('idInstitucion'));    
    this.personalizacion();
    this.getPeriodos();
  }
  ngOnInit(): void {
  }
  private personalizacion(){
    var configInst = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion);
    this.bndInteres = configInst.interes;
    this.submenus = configInst.tipoMenu;
    this.smMoneda = configInst.moneda;
  }
  // **** Funciones de la consulta y tratamiento de datos ****
  FuncionesDataSource(){
    this.concentracion.InstitucionId = this.idInstitucion;
    this.concentracion.Periodo = this.periodo;
    this.concentracion.ElementoAgrupador = 'EstatusCredito';
    // this.concentracion.BnIntereses = this.bndInteres;
    this.funcionConcentracion(this.concentracion);
  }

  private async getPeriodos(){
    const info = await firstValueFrom(
      this.periodosService.getByAddUrl_Riesgo('informacionCargada', {InstitucionId: this.idInstitucion})
    );
    if(info.length > 0){
      this.DatosAnios = formatear.periodosRC(info);
      this.periodo = Number(this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].value);
      this.mes = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].name;
      this.anio = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].year;
      this.DatosAnios.aniosDisponibles[this.DatosAnios.aniosDisponibles.length-1].check = true;
      this.FuncionesDataSource();
      this.getDatos();
    }else{
      var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }
    
  }
  async funcionConcentracion(concentracionEntity: any){
    try{
      const res = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',concentracionEntity)); 
      this.maydeud(res);
      if(!this.persepectiva){
        this.mayoresdeudores.InstitucionId = this.idInstitucion;
        this.mayoresdeudores.Periodo = this.periodo;
        this.mayoresdeudores.NDatosLimite = this.numDeud;
        this.mayoresdeudores.BnAgruparDatos= 1;
        // this.mayoresdeudores.BnIntereses= this.bndInteres;
        this.funcionMayoresDeudoresSinInteres(this.mayoresdeudores);
      }else{
        this.concentracionPer.InstitucionId = this.idInstitucion;
        this.concentracionPer.Periodo = this.periodo;
        this.concentracionPer.ElementoAgrupador = 'agrupadorDos';
        // this.concentracionPer.BnIntereses = this.bndInteres;
        this.funcionMayoresDeudoresSinInteres(this.concentracionPer);
      }
      this.actsubtitulos();
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async funcionMayoresDeudoresSinInteres(mayoresdeudoresEntity: any){
    try{
      if(!this.persepectiva){
        const res = await firstValueFrom(this.mayoresdeudoresService.getByAddUrl_Riesgo('mayoresDeudores',mayoresdeudoresEntity));
        this.Datos(res);
      }else{
        const res = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',mayoresdeudoresEntity));
        this.Datos(res);
      }       
    }catch(err){
      messages.errorMessageGraph(err);
    }    
  }
  maydeud(arreglo: any []){
    var aux: number =0;
    for(var i= 0; i<arreglo.length; i++){
      aux+=arreglo[i].Saldo_Actual;
    }
    this.total = aux;
  }
  Datos(arreglo: any []){
    var aux = [];
    this.multi2 = [];
    this.etiquetas = []
    if(!this.persepectiva){
      for(var i= 0; i<arreglo.length; i++){
        aux.push({name: arreglo[i].Nombre_Socio, value: arreglo[i].Saldo_Actual, clave: arreglo[i].Clave_Socio});
      }
    }else{
      var tam = this.numDeud+1;
      if(tam > arreglo.length ){
        tam = arreglo.length;
      }
      for(var i= 0; i<tam; i++){
        if(arreglo[i].ElementoAgrupador != 'Sin Datos')
          aux.push({name: arreglo[i].ElementoAgrupador, value: arreglo[i].Saldo_Actual, clave: arreglo[i].Clave_Socio});
      }
    }
    this.multi = aux;
    var aux2 = [];
    var cantidades = [];
    for(var j=0; j<aux.length; j++){
      if(!this.persepectiva){
        this.etiquetas.push((j+1)+'.- '+aux[j].clave);
        cantidades.push(aux[j].value);
      }else{
        this.etiquetas.push(aux[j].clave);
        cantidades.push(aux[j].value);
      }
    }
    aux2.push({name:'', data:cantidades})
    this.multi2 = aux2;
    this.mayordeud = this.multi2[0].value;
    this.DatosTabla(this.multi);
  }
  DatosTabla(arreglo: any []){
    var aux = [];
    this.data = [];
    this.suma =0;
    if(!this.persepectiva){
    this.Mayores_deudores = 'Mayores deudores';
    }
    for(var u = 0; u < arreglo.length;u++){
      aux.push({position: u+1, clave:arreglo[u].clave, name: arreglo[u].name, weight: this.formatearnormal(arreglo[u].value,this.miles1)});
      this.suma += arreglo[u].value;
    }
    aux.push({position: '' ,clave: 'Total:',nombre: '', weight: this.formatearnormal(this.suma.toFixed(2),this.miles1)});
    this.dataSource = aux;
    aux = [];
    this.datosdelPie();
  }
  // **** Funciones de filtrado ****
  quitar_filtros(){
    var pos = 0;
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;

    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false;
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[this.aniosDisponibles.length-1].name){
        aux.push(this.DatosAnios.mesesDisponibles[i]);
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[this.aniosDisponibles.length-1].name;
    
    this.miles1 = true
    this.milTab1 = '(Miles)'
    this.persepectiva = false;

    this.numDeud = 20;
    this.ndeud10 = false;
    this.ndeud20 = true;
    this.ndeud30 = false;
    this.ndeud40 = false;
    this.ndeud50 = false;
    
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);
    this.FuncionesDataSource();

    //Variables graficas zoana 1
    this.gtablas = false;
    this.tipoSelec = this.tipoGraf.BARHORIZONTAL;
    this.showDataLabel = false;
    //Variables graficas zona 2
    this.tablaPie = false;
    this.tipoSelec2 = this.tipoGraf.DONUT;
    this.showLabelsPie = false;
  }
  async getDatos(){    
    this.aniosDisponibles = this.DatosAnios.aniosDisponibles;
    var aux = [];
    var pos;
    for(var i = 0; i < this.aniosDisponibles.length; i ++){
      if(this.aniosDisponibles[i].check == true){
        pos = i;
      }
    }
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i]);
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
  }
  /* funciones para los filtros */
  //AÑOS
  public anioChange(anio: any){
    var pos = 0;
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    for(var i =0; i < this.aniosDisponibles.length; i++){
      if(this.aniosDisponibles[i].value == anio.value){
        this.aniosDisponibles[i].check = true;
        pos = i;
      }
    }
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);
    this.FuncionesDataSource();
  }
  public mesChange(mes: any){
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false;
    }
    var pos =0;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      if(this.mesesDisponibles[i].name == mes.name){
        this.mesesDisponibles[i].check = true;
        pos = i;
      }
    }
    this.mes = this.mesesDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[pos].value);
    this.FuncionesDataSource();
  }
  actsubtitulos(){
    if(!this.persepectiva){
      this.Title = 'Mayores deudores';
      this.Subtitulo_grafica =this.mes +' • '+ this.anio.substring(2,4) +' | matriz | '+this.numDeud+' mayores deudores';
    }else{
      this.Title = 'Grupos de riesgo';
      this.Subtitulo_grafica =this.mes +' • '+ this.anio.substring(2,4) +' | matriz | '+this.numDeud+' mayores grupos de riesgo';
    }
    this.mesAnio = this.mes + ' ' + this.anio.substring(2,4);
  }
  // **** Funciones numero de deudores ****
  Ndeudores(e: any){
    if(e == 10){
      this.numDeud = 10;
      this.ndeud10 = true;
      this.ndeud20 = false;
      this.ndeud30 = false;
      this.ndeud40 = false;
      this.ndeud50 = false;
    }
    if(e == 20){
      this.numDeud = 20;
      this.ndeud10 = false;
      this.ndeud20 = true;
      this.ndeud30 = false;
      this.ndeud40 = false;
      this.ndeud50 = false;
    }
    if(e == 30){
      this.numDeud = 30;
      this.ndeud10 = false;
      this.ndeud20 = false;
      this.ndeud30 = true;
      this.ndeud40 = false;
      this.ndeud50 = false;
    }
    if(e == 40){
      this.numDeud = 40;
      this.ndeud10 = false;
      this.ndeud20 = false;
      this.ndeud30 = false;
      this.ndeud40 = true;
      this.ndeud50 = false;
    }
    if(e == 50){
      this.numDeud = 50;
      this.ndeud10 = false;
      this.ndeud20 = false;
      this.ndeud30 = false;
      this.ndeud40 = false;
      this.ndeud50 = true;
    }
    this.actsubtitulos();
    this.FuncionesDataSource();
  }
  // **** Funcion de seleccion ****
  onSelect(e: any){
    this.Mayores_deudores = 'Deudor '+e.name.split('-')[0];
    this.suma = e.value;
    this.datosdelPie();
  }
  // **** Función de formateo de datos ****
  formatearnormal2(num: any){
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  formatearnormal(num: any, miles: any){
    if(miles == true)
      num = (num/1000).toFixed(2);
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  desForm(num: any){
    if(num.includes(',')){
      var pos = num.indexOf(',');
      var aux = num.slice(0,pos)+num.slice(pos+1);
      num = aux
      while(num.includes(',')){
        var pos = num.indexOf(',');
        var aux = num.slice(0,pos)+num.slice(pos+1);
        num = aux
      }
    }
    num = Number(num);
    return num;
  }
  CambMon( moneda: any, tab: any ){
    if(moneda == 'Mil' && tab == 1){
      this.miles1 = true;
      this.milTab1 = '(Miles)';
    }
    if(moneda == 'Pesos' && tab == 1 ){
      this.miles1 = false;
      this.milTab1 = '';
    }
    this.FuncionesDataSource();
  }
  // **** Función de porcentaje ****
  PorcentajeTot(num: any){
    num=num*100/this.total;
    return num.toFixed(2);
  }
  // **** Exportar ****
  export_csv(){
    var aux = [];
    var data_excel: any = [];
    var name = '';
    //this.desForm(this.dataSource[0].mes2)
    var encabezado_excel = ['No','Clave del socio','Nombre del socio','Saldo'];
    var cadena_evaluacion = encabezado_excel;
    name = this.numDeud+' '+this.Title ;
    for(var i = 0; i < this.dataSource.length; i++){
      aux.push(this.dataSource[i].position);
      aux.push(this.dataSource[i].clave);
      aux.push(this.dataSource[i].name);
      aux.push(this.desForm(this.dataSource[i].weight));
      data_excel.push(aux);
      aux = [];
    }
    let nombre = "";
    if(this.gtablas){
      nombre = this.Title+ " " +this.milTab1 ;
    }else{
      nombre = this.Title;
    }

    let titHoja = this.translate.instant('menu.'+this.dataService.moduleSelect) + " " + nombre + " " + this.Subtitulo_grafica; 
    this.excelservices.generateExcelMayDeud(titHoja,encabezado_excel,data_excel,cadena_evaluacion.length,nombre);
  }
  export_img(zon: any){
    var nombreGraf = {titulo: '', subtitulo:'', nombreArch: ''};

    if(zon === 1){
      nombreGraf.titulo = this.Title;
      nombreGraf.subtitulo = this.Subtitulo_grafica;
      nombreGraf.nombreArch = this.Title;
    }
    if(zon === 2){
      nombreGraf.titulo = `${this.translate.instant('riesgo-credito.mayores.titTab')} ${this.Mayores_deudores}`;
      nombreGraf.subtitulo =  this.mes +' • '+ this.anio.substring(2,4);
      nombreGraf.nombreArch = `${this.translate.instant('riesgo-credito.mayores.titTab')} ${this.Mayores_deudores}`;
    }
    const comp = this.grafCmp.find(g => g.zona === zon);
    comp.exportImg(zon,nombreGraf)
  }
  // **** Actualización de los datos del pie ****
  datosdelPie(){
    this.datosTablaPie = [];
    var Saux2: any = this.suma;
    var Saux: any = this.total-this.suma;
    var aux: number = Number(Saux);
    var aux2: number = Number(Saux2);
    this.datos_pie = [{name: 'a', data: [aux, aux2]}];
    this.etiquetasPie = [this.translate.instant('riesgo-credito.mayores.etiPie2'), this.translate.instant('riesgo-credito.mayores.etiPie')];
    this.datosTablaPie.push({name: this.etiquetasPie[0], value: Number(aux.toFixed(2)), porcen: Number((aux/this.total*100).toFixed(1))});
    this.datosTablaPie.push({name: this.etiquetasPie[1], value: Number(aux2.toFixed(2)), porcen: Number((aux2/this.total*100).toFixed(1))});
  }
  // **** Funcones de activación de graficas normales y modales ****
  //Graficas zona 1
  public tablaGraf(opt, type?){
    if(opt === 'tabla'){
      this.gtablas = true;
    }else{
      this.gtablas = false; 
      if(type === typesApex.BAR){
        this.xAxisLabel = 'Nombre socio';
        this.yAxisLabel = ['Saldo']
      }else{
        this.xAxisLabel = 'Saldo';
        this.yAxisLabel = ['Nombre socio'];
      }
      this.tipoSelec = type;
    }
  }
  ampliar(){
    if(this.gtablas){
      this.titleModal = `${this.Title} ${this.milTab1}`;
      this.subtitleModal = this.Subtitulo_grafica;
      this.gtablasModal = true;
      this.iconoExportar = 'description';
      this.labelsModal = false;
    }else{
      this.titleModal = this.Title;
      this.subtitleModal = this.Subtitulo_grafica;
      this.gMayoresModal = true;
      this.iconoExportar = 'image';
      this.labelsModal = true;
    }
    this.modalOpen = !this.modalOpen;
  }
  //Graficas zona 2
  public tablaGraf2(opt, type?){
    if(opt == 'tabla'){
      this.tablaPie = true;
    }else{
      this.tablaPie = false;
      this.tipoSelec2 =type; 
    }
  }
  //Graficas del Modal
  async ampliarG2(){
    this.titleModal = `${this.translate.instant('riesgo-credito.mayores.titTab')} ${this.Mayores_deudores}`;
    this.subtitleModal = this.mes +' • '+ this.anio.substring(2,4);
    this.gCarteraModal = true;
    this.iconoExportar = 'image';
    this.modalOpen = !this.modalOpen;
  }
  cerrarAmp(){
    this.gtablasModal = false;
    this.gMayoresModal = false;
    this.gCarteraModal = false;
    this.modalOpen = false;
  }
  public exportSaldos(){
    var titulos = [
      this.translate.instant('riesgo-credito.mayores.titTab1'),
      this.translate.instant('riesgo-credito.mayores.titTab2'),
      this.translate.instant('riesgo-credito.mayores.titTab3')
    ]

    var alineacion = [Aligment.LEFT, Aligment.RIGHT, Aligment.RIGHT];
    var formato = [FormatText.TEXT, FormatText.NUMBER, FormatText.PORCENTAJE];

    var data = [];
    for(const d of this.datosTablaPie){
      var aux = [];
      aux.push(d.name);
      aux.push(d.value);
      aux.push(d.porcen/100);
      data.push(aux);
    }

    var tituloHoja = this.translate.instant('riesgo-credito.mayores.titTab') + ' ' + this.Mayores_deudores;
    var nombreArch = this.translate.instant('riesgo-credito.mayores.nombreArchPie');
    this.excelservices.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato);
  }
  public exportarModal(){
    if(this.gtablasModal){
      this.export_csv();
    }
    if(this.gCarteraModal){
      this.export_img(2);
    }
    if (this.gMayoresModal) {
      this.export_img(1);
    }
  }
  public showLabels(){
    if(this.gMayoresModal){
      return this.showDataLabel;
    }
    if(this.gCarteraModal){
      return this.showLabelsPie;
    }
    return false;
  }
  public changeLabels(){
    if(this.gMayoresModal){
      this.showDataLabel = !this.showDataLabel;
    }
    if(this.gCarteraModal){
      this.showLabelsPie = !this.showLabelsPie;
    }
  }
  
}
